import React from "react";
import ReactLoading from "react-loading";

export default function Loading(props) {
  return (
    <ReactLoading
      type={props.type}
      color={props.color}
      height={32}
      width={38}
    />
  );
}
